import { Outlet } from 'react-router';

import useDocumentTitle from '@/hooks/useDocumentTitle';

const SparePartsCollectionsSection = () => {
  useDocumentTitle({
    resourceTitle: 'Cobranzas de repuestos',
    showTitle: 'Cobranza {id}',
  });

  return (
    <div className="SparePartsCollectionsSection MainSection">
      <Outlet />
    </div>
  );
};

export default SparePartsCollectionsSection;
